<template>
  <div id="basketball_scheduleDetail" v-show="currThemeObj">
    <div class="abs_top">
      <div class="teamLogoBgRow">
        <span class="imageSpan">
          <img
            v-if="matchPanel_matchInfor && matchPanel_matchInfor.homeTeamLogo"
            :src="matchPanel_matchInfor.homeTeamLogo"
          />
        </span>
        <span class="imageSpan">
          <img
            v-if="matchPanel_matchInfor && matchPanel_matchInfor.awayTeamLogo"
            :src="matchPanel_matchInfor.awayTeamLogo"
          />
        </span>
      </div>
      <div class="matchPanel_abs">
        <scheduleDetail_matchPanel
          :currThemeObj="currThemeObj"
          :matchInfor="matchPanel_matchInfor"
          :periodsArr="matchPanel_periodsArr"
          :logoRatio="logoRatio"
        ></scheduleDetail_matchPanel>
      </div>
      <div class="selectTab_area" v-if="tabArr && tabArr.length > 0">
        <selectTab
          :currThemeObj="currThemeObj"
          :tabArr="tabArr"
          :pageJumpParams="selectTab_pageJumpParams"
          @clickTabEvent="onChangeTab"
          :colorsArr="selectTab_colorsArr"
        ></selectTab>
      </div>
    </div>
    <div>
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :matchInfor="matchPanel_matchInfor"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :curTimeZoneItem="curTimeZoneItem"
        :sportCompetitionType="sportCompetitionType"
      ></router-view>
    </div>
  </div>
</template>

<script>
import scheduleDetail_matchPanel from './scheduleDetail_matchPanel.vue'
import selectTab from '@components/platfromBase/compreSportsMeet/selectTab.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

import { https_schedule_matchDetail } from '@api/platfrom_basketball_api'
export default {
  name: 'basketball_scheduleDetail',
  components: { scheduleDetail_matchPanel, selectTab },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      isRefresh: false, //是否需要实时更新
      refreshTime: 30 * 1000, //定时器刷的时间 默认
      setIntervalId: null,
      matchPanel_periodsArr: [],
      basketballCupCidArr: ['202', '203'],
      matchPanel_matchInfor: {
        leagueName: '',
        gameDateWeb: '',
        matchStatus: '',
        homeWinLoss: '',
        awayWinLoss: '',
        homeId: '',
        homeTeam: '',
        homeTeamPoints: '-',
        homeTeamLogo: '',
        awayId: '',
        awayTeam: '',
        awayTeamPoints: '-',
        awayTeamLogo: '',
        currentPeriodName: '',
        timeMinutes: 0,
        timeSeconds: 0,
      },
      tabArr_league: [
        {
          name: '赛前分析',
          id: 'preMatch',
          pathName: 'scheduleDetailPreMatch',
          act: true,
        },
        {
          name: '数据分析',
          id: 'analysis',
          pathName: 'scheduleDetailAnalysis',
          act: false,
        },
        {
          name: '投篮分布',
          id: 'hotspots',
          pathName: 'scheduleDetailHotspots',
          act: false,
        },
        {
          name: '数据统计',
          id: 'statistics',
          pathName: 'scheduleDetailStatistics',
          act: false,
        },
      ],
      tabArr_cup: [
        {
          name: '出场名单',
          id: 'startList',
          pathName: 'scheduleDetailStartList',
          act: true,
        },
        {
          name: '赛前分析',
          id: 'preMatch',
          pathName: 'scheduleDetailPreMatch',
          act: false,
        },
        {
          name: '数据分析',
          id: 'analysis',
          pathName: 'scheduleDetailAnalysis',
          act: false,
        },
        {
          name: '数据统计',
          id: 'statistics',
          pathName: 'scheduleDetailStatistics',
          act: false,
        },
      ],
      tabArr: [],
      selectTab_pageJumpParams: [],
      selectTab_colorsArr: null,
      selectTab_colorsKey: [
        'greyColor7',
        'whiteColor',
        'greyColor2',
        'subColor1_1',
      ],
      logoRatio: '', // 控制 matchPanel 中国旗的尺寸比例，目前只有2种【联赛1:1(''默认)， 杯赛3:2（WH-3V2）】
    }
  },
  watch: {
    isRefresh(newVal, oldVal) {
      console.debug(`lineup isRefresh: ${newVal}, ${oldVal}`)
      if (newVal && !oldVal) {
        this.refreshCallbackHandle()
      } else if (!newVal && oldVal) {
        this.cancelRefreshCallBackHandle()
      }
    },
  },
  created() {
    if (this.currThemeObj) {
      if (this.basketballCupCidArr.includes(this.currCid)) {
        // 篮球杯赛
        this.logoRatio = 'WH-3V2'
        this.tabArr = this.tabArr_cup
      } else {
        this.tabArr = this.tabArr_league
      }
      this.tabArr.forEach((item) => {
        item.pathName = `${item.pathName}_${this.currThemeObj.moduleRouteNameEn}` // teamDetailPlayerList_CBA
      })
    }
    const query = this.$route.query
    this.selectTab_pageJumpParams = [query, null]
    if (query) {
      this.init(query)
    }
  },
  methods: {
    async init(params) {
      // this.origin_matchList = matchList_mock.dat
      if (params) {
        if (this.currThemeObj) {
          this.selectTab_colorsArr = this.selectTab_colorsKey.map((key) => {
            return this.currThemeObj.cssStyle[key]
          })
        }
        await this.getScheduleDetail(params)
      }
    },
    cancelRefreshCallBackHandle() {
      clearInterval(this.setIntervalId)
      this.setIntervalId = null
    },
    refreshCallbackHandle() {
      const query = this.$route.query
      console.debug('refreshCallbackHandle:', this.refreshTime, query)
      this.setIntervalId = setInterval(() => {
        this.getScheduleDetail(query)
      }, this.refreshTime - 0)
    },
    onChangeTab(item) {
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
    },
    _valFormatHandler(val) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '-'
      } else {
        data = val
      }
      // console.debug(val, data)
      return data
    },
    async getScheduleDetail(query) {
      let params = {
        cid: query.cid,
        sid: query.sid,
        matchId: query.mid,
      }
      await https_schedule_matchDetail(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let matchDetail = res.data
            // if (this.setIntervalId) {
            //   clearTimeout(this.setIntervalId)
            // }
            if (matchDetail.matchStatus === 1) {
              this.refreshTime = 30 * 1000 //未开始 半分钟扫一次
            } else if (matchDetail.matchStatus === 2) {
              matchDetail.periodStatus + ' ' + matchDetail.minutes
              this.refreshTime = 6 * 1000 //进行中 6秒扫一次
            } else {
              // 其他情况按照已经结束出来
              this.refreshTime = 24 * 60 * 60 * 1000 //已结束 一天扫一次
            }
            this.isRefresh = true // 默认不论什么比赛状态都是开启定时刷，只是时间不一样

            this.matchPanel_matchInfor = {
              //banner 上面的数据
              leagueName: matchDetail.matchName,
              gameDate: matchDetail.gameDate ? matchDetail.gameDate : '', //比赛日期
              matchStatus: matchDetail.matchStatus
                ? matchDetail.matchStatus
                : null, //比赛状态，1：未开始，2：进行中，4：已结束
              homeId: matchDetail.homeId,
              awayId: matchDetail.awayId,
              awayTeam: matchDetail.awayNameAbbr
                ? matchDetail.awayNameAbbr
                : '', //客队
              homeTeam: matchDetail.homeNameAbbr
                ? matchDetail.homeNameAbbr
                : '', //主队
              homeTeamPoints:
                matchDetail.matchStatus === 1
                  ? '-'
                  : matchDetail.homeScore && matchDetail.homeScore > 0
                  ? matchDetail.homeScore
                  : '0', //主队得分
              homeTeamLogo: matchDetail.homeLogo ? matchDetail.homeLogo : '', // _this.default_teamLogoSquare, //主队logo
              awayTeamLogo: matchDetail.awayLogo ? matchDetail.awayLogo : '', // _this.default_teamLogoSquare, //客队logo
              awayTeamPoints:
                matchDetail.matchStatus === 1
                  ? '-'
                  : matchDetail.awayScore && matchDetail.awayScore > 0
                  ? matchDetail.awayScore
                  : '0', //客队得分
              gameDateWeb: `${
                matchDetail.matchDate ? matchDetail.matchDate : ''
              } ${matchDetail.matchTime ? matchDetail.matchTime : ''}`,
              homeWinLoss: `${this._valFormatHandler(
                matchDetail.homeWins
              )}胜${this._valFormatHandler(matchDetail.homeLosses)}负`,
              awayWinLoss: `${this._valFormatHandler(
                matchDetail.awayWins
              )}胜${this._valFormatHandler(matchDetail.awayLosses)}负`,
              currentPeriodName: matchDetail.currentPeriodName,
              timeMinutes: matchDetail.timeMinutes,
              timeSeconds: matchDetail.timeSeconds,
            }

            let periodsArr = []
            let stageTitleArr = []
            let stageHomeArr = []
            let stageAwayArr = []
            if (matchDetail.periodScore && matchDetail.periodScore.length) {
              let stageNum = matchDetail.periodScore.length
              let title = ''
              for (let i = 0; i < stageNum; i++) {
                // if(i===10) break
                if (i < 4) {
                  title = 'Q' + (i + 1)
                } else {
                  title = 'T' + (i - 3)
                }
                const periodsHomeScore = matchDetail.periodScore[i]
                  .homePeriodScore
                  ? matchDetail.periodScore[i].homePeriodScore
                  : ''
                const periodsAwayScore = matchDetail.periodScore[i]
                  .awayPeriodScore
                  ? matchDetail.periodScore[i].awayPeriodScore
                  : ''

                stageTitleArr.push({
                  index: i,
                  class: '',
                  val: title,
                })
                stageHomeArr.push({
                  index: i,
                  class: periodsHomeScore < periodsAwayScore ? 'lossColor' : '',
                  val: periodsHomeScore,
                })

                stageAwayArr.push({
                  index: i,
                  class: periodsAwayScore < periodsHomeScore ? 'lossColor' : '',
                  val: periodsAwayScore,
                })
              }
              periodsArr.push({
                name: '',
                class: 'stageTitle_ul',
                arr: stageTitleArr,
                key: 'title',
              })

              periodsArr.push({
                name: this.matchPanel_matchInfor.homeTeam,
                class: 'stageScore_ul',
                arr: stageHomeArr,
                key: 'home',
              })
              periodsArr.push({
                name: this.matchPanel_matchInfor.awayTeam,
                class: 'stageScore_ul',
                arr: stageAwayArr,
                key: 'away',
              })
            }

            this.matchPanel_periodsArr = periodsArr
            console.debug(
              'matchPanel:',
              this.matchPanel_matchInfor,
              this.matchPanel_periodsArr
            )

            // this.isRefresh = true //测试

            // 为了测试赛前这里暂时注释掉
            // if (
            //   paramsItem.matchStatus == 'Playing' ||
            //   paramsItem.matchStatus == 'Suspended' ||
            //   paramsItem.matchStatus == 'Played'
            // ) {
            //   if (this.$route.name == `scheduleDetailPreMatch_${this.currThemeObj.moduleRouteNameEn}`) {
            //     // 如果比赛进行时或者比赛结束时，进入赛前tab的默认进入阵容tab
            //     console.debug(this.$route)
            //     this.$router.replace({
            //       name: `scheduleDetailLineup_${this.currThemeObj.moduleRouteNameEn}`,
            //       query: query,
            //     })
            //   }
            //   setTimeout(() => {
            //     this.tabArr = [
            //       {
            //         name: '阵容',
            //         id: 'lineup',
            //         pathName: `scheduleDetailLineup_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: true,
            //       },
            //       {
            //         name: '数据分析',
            //         id: 'analysis',
            //         pathName: `scheduleDetailAnalysis_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: false,
            //       },
            //       {
            //         name: '数据统计',
            //         id: 'statistics',
            //         pathName: `scheduleDetailStatistics_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: false,
            //       },
            //     ]
            //   }, 10)
            // }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              if (
                this.matchPanel_matchInfor &&
                this.matchPanel_matchInfor.matchId
              ) {
              } else {
                this.matchPanel_matchInfor = null
              }
              // this.$message({
              //   showClose: true,
              //   message: res.message ? res.message : '服务器异常，请稍后再试',
              //   type: 'warning',
              // })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#basketball_scheduleDetail {
  padding-top: 20.833vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 20.833vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_scheduleDetail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .teamLogoBgRow {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      opacity: 0.2;
      .imageSpan {
        width: 20.833vw;
        height: 20.833vw;
        overflow: hidden;
        img {
          display: block;
          filter: grayscale(100%);
          -webkit-user-select: none;
          -moz-user-select: none;
          user-select: none;
          pointer-events: none;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .matchPanel_abs {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5;
      padding: 0 9.722vw;
      width: 100%;
      height: 100%;
    }
    .selectTab_area {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0 9.722vw;
      width: 100%;
      height: 2.778vw;
    }
  }
}
</style>
